/**
 * Default-scene field that names the banner the background selector draws a
 * background's crop preview on: the horizontal banner whose crop the admin
 * changed last before the save. It travels with the crop fields, so it lands
 * on the row the crop resolves from.
 */
export const BG_PREVIEW_TEMPLATE_FIELD = "bgPreviewTemplate";
